import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dismissUpdateAvailable } from '../../../store/slices/uiSlice';
import './AppUpdateModal.css';

/**
 * Global modal shown when Socket.IO receives an `app-update` event after a deployment.
 * Mounted at the App root so it works on login and authenticated screens.
 */
const AppUpdateModal = () => {
  const dispatch = useDispatch();
  const updateAvailable = useSelector((state) => state.ui.updateAvailable);
  const refreshRef = useRef(null);

  useEffect(() => {
    if (!updateAvailable) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    refreshRef.current?.focus();

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [updateAvailable]);

  if (!updateAvailable) return null;

  const handleRefreshNow = () => {
    window.location.reload();
  };

  const handleLater = () => {
    dispatch(dismissUpdateAvailable());
  };

  return (
    <div className="app-update-overlay" role="presentation">
      <div
        className="app-update-container"
        role="dialog"
        aria-modal="true"
        aria-labelledby="app-update-title"
        aria-describedby="app-update-message"
      >
        <div className="app-update-header">
          <h5 id="app-update-title" className="app-update-title">
            New Update Available
          </h5>
        </div>
        <div className="app-update-body">
          <p id="app-update-message">
            A new version of the application has been deployed. Please refresh the page to
            continue using the latest version.
          </p>
        </div>
        <div className="app-update-footer">
          <button
            type="button"
            className="app-update-btn-later"
            onClick={handleLater}
          >
            Later
          </button>
          <button
            type="button"
            className="app-update-btn-refresh"
            onClick={handleRefreshNow}
            ref={refreshRef}
          >
            Refresh Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppUpdateModal;
